
export class LicensesCardModel {
    class: string;
    id: number;
    optimistic: string;
    modifiedon: number;
    lazyProperties: string;
    effectiveStatus: string;
    spCode: string;
    extID: string;
    createdOn: number;
    clientId: string;
    type: string;
    customerAccountID: number;
    customerAccountName: string;
    specExtID: string;
    brokerAccountClientId: string;
    billingClientId: string;
    serviceOfferCode: string;
    serviceOfferingName: string;
    specName: string;
    attributes: Array<String>;
    status: string;
    features: Array<String>;
    subscriptionId: string;
    quantity: number;
    totalLicensesInUse: number;
    name: string;
    useLicenseManagement: boolean;
    provisionStatus: string;
    fanType: string;

    constructor() {
        this.class = undefined;
        this.id = undefined;
        this.optimistic = undefined;
        this.modifiedon = undefined;
        this.lazyProperties = undefined;
        this.effectiveStatus = undefined;
        this.spCode = undefined;
        this.extID = undefined;
        this.createdOn = undefined;
        this.clientId = undefined;
        this.type = undefined;
        this.customerAccountID = undefined;
        this.customerAccountName = undefined;
        this.specExtID = undefined;
        this.brokerAccountClientId = undefined;
        this.billingClientId = undefined;
        this.serviceOfferCode = undefined;
        this.specName = undefined;
        this.attributes = undefined;
        this.status = undefined;
        this.features = undefined;
        this.subscriptionId = undefined;
        this.quantity = undefined;
        this.totalLicensesInUse = undefined;
        this.name = undefined;
        this.useLicenseManagement = undefined;
        this.provisionStatus = undefined;
        this.serviceOfferingName = undefined;
        this.fanType = undefined;
    }
}
